import React from "react";
import { Field } from "redux-form";
import { TextField } from "redux-form-material-ui";
import styled from 'styled-components'

// import Card from "../../../components/Card";

import "./styles.css";

const ErrorMessage = styled.div`
  color: red;
  text-align: center;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 15px;
`;


const muiStyles = {
  inputStyle: {
    fontWeight: "400",
    fontFamily: '"Montserrat", sans-serif'
  }
};

const TripSearchForm = ({ onSearch, errorFetchTripById }) => (
  <div class="trip-search-form__wrapper">
    <h3 class="trip-search-form__header"> Find My Trip </h3>
    <div class="trip-search-form">
      <Field
        // class=""
        name="customerEmail"
        component={TextField}
        floatingLabelText="Enter email"
        hintStyle={muiStyles.inputStyle}
        inputStyle={muiStyles.inputStyle}
        floatingLabelStyle={muiStyles.inputStyle}
        fullWidth
      />
      <Field
        // class=""
        name="tripId"
        component={TextField}
        floatingLabelText="Enter reservation number"
        hintStyle={muiStyles.inputStyle}
        inputStyle={muiStyles.inputStyle}
        floatingLabelStyle={muiStyles.inputStyle}
        fullWidth
      />
    </div>
    <button onClick={onSearch} class="btn btn-primary trip-search-form__btn"> Search </button>
    {errorFetchTripById && <ErrorMessage> {errorFetchTripById} </ErrorMessage>}
  </div>
);

export default TripSearchForm;



// WEBPACK FOOTER //
// ./src/scenes/TripSearchPage/TripSearchForm/index.js